<vpg-card-next-header class="claims-module-loader-heading">
    <vpg-card-next-title>{{ translations.RECENT_CLAIMS | translate }}</vpg-card-next-title>
</vpg-card-next-header>
<img
    class="module-loader-spinner"
    src="img/loading.gif"
    alt=""
/>
